import React from 'react';
import {
  TextField,
  MenuItem,
  Typography,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
} from '@mui/material';
import { FormControlStyled, FormLabelStyled } from '../../../common/Dialog/DialogGlynt';
import { TemplateFileFormat } from '../../../../types/packager-types';
import { AvailableColumn } from '../../../hooks/packager/useGetAvailableColumns';

interface TemplateOutputOptionsProps {
  fileFormat: TemplateFileFormat;
  splitBy: string;
  defaultSplitValue: string;
  splitByFields: AvailableColumn[];
  onFileFormatChange: (format: TemplateFileFormat) => void;
  onSplitByChange: (value: string) => void;
  onDefaultSplitValueChange: (value: string) => void;
}

const TemplateOutputOptions: React.FC<TemplateOutputOptionsProps> = ({
  fileFormat,
  splitBy,
  defaultSplitValue,
  splitByFields,
  onFileFormatChange,
  onSplitByChange,
  onDefaultSplitValueChange,
}) => {
  return (
    <FormControlStyled sx={{ mt: 0 }}>
      <FormLabelStyled>OUTPUT</FormLabelStyled>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Format
          </Typography>
          <RadioGroup
            row
            value={fileFormat}
            onChange={(e) => onFileFormatChange(e.target.value as TemplateFileFormat)}
          >
            <FormControlLabel
              value={TemplateFileFormat.CSV}
              control={<Radio size="small" />}
              label="CSV"
            />
            <FormControlLabel
              value={TemplateFileFormat.JSON}
              control={<Radio size="small" />}
              label="JSON"
            />
          </RadioGroup>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Split By
          </Typography>
          <Select
            size="small"
            fullWidth
            variant="outlined"
            value={splitBy}
            onChange={(e) => onSplitByChange(e.target.value)}
          >
            <MenuItem value="">None</MenuItem>
            {splitByFields.map((f) => (
              <MenuItem key={f.name} value={f.name}>
                {f.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Default Split Value
          </Typography>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            placeholder="unknown"
            value={defaultSplitValue}
            onChange={(e) => onDefaultSplitValueChange(e.target.value)}
            disabled={!splitBy}
          />
          <Typography variant="caption" color="text.secondary">
            Used when split field is empty
          </Typography>
        </Box>
      </Box>
    </FormControlStyled>
  );
};

export default TemplateOutputOptions;
